import { render, staticRenderFns } from "./RecentlyViewed.vue?vue&type=template&id=6ea3b772&"
import script from "./RecentlyViewed.vue?vue&type=script&lang=ts&"
export * from "./RecentlyViewed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports